import { DefaultThemeValueType } from "../../../../styled";

export type ProductCategoryStyle = {
  textColor: DefaultThemeValueType;
  background: DefaultThemeValueType;
};

export type HeaderProps = {
  hidden: boolean;
};

export type HeaderSectionProps = {
  sectionData: any;
  sectionName: string;
  activeButton: string;
  onPress: (item: any) => void;
  headerHeight: number;
  headerBackgroundColor: string;
};

export enum ActiveButtonsEnum {
  SEARCH_MARKETPLACE = "search-marketplace",
  BULK_LIST = "bulk-list",
  USER_PROFILE = "user-profile",
  ORDER_CART = "order-cart",
  PROFILE = "profile",
  LOGO = "logo",
  ADVERTISEMENT = "advertisement",
  SEARCH = "search",
  LINK = "link",
  SHOPPING_CART = "shopping-cart",
}
